function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M822.139,12155.929a5.077,5.077,0,0,1-3.553-1.433,8.929,8.929,0,0,1-1.121-1.372.491.491,0,1,1,.823-.537,7.878,7.878,0,0,0,.984,1.205,4.133,4.133,0,0,0,5.735,0l3.67-3.582a3.864,3.864,0,0,0,0-5.563,4.128,4.128,0,0,0-5.735,0l-2.423,2.34a.491.491,0,1,1-.682-.707l2.421-2.338a5.117,5.117,0,0,1,7.1,0,4.849,4.849,0,0,1,0,6.972l-3.67,3.582A5.074,5.074,0,0,1,822.139,12155.929Z",
  transform: "translate(-810.84 -12142.508)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M802.417,12176.021a5.075,5.075,0,0,1-3.554-1.435,4.849,4.849,0,0,1,0-6.972l3.67-3.581a5.119,5.119,0,0,1,7.106,0,8.858,8.858,0,0,1,1.121,1.372.491.491,0,1,1-.823.536,7.882,7.882,0,0,0-.984-1.205,4.132,4.132,0,0,0-5.735,0l-3.669,3.581a3.864,3.864,0,0,0,0,5.563,4.129,4.129,0,0,0,5.735,0l2.424-2.34a.491.491,0,0,1,.682.708l-2.421,2.338A5.072,5.072,0,0,1,802.417,12176.021Z",
  transform: "translate(-797.385 -12156.021)"
});

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgLink, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Link.67ae7ec9.svg";
export { ForwardRef as ReactComponent };